import { FIND_SPOT_LIST_REQUEST, findSpotListSuccess, findSpotListFailure} from 'Redux/Action';
import { ofType } from 'redux-observable';
import { from, EMPTY } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { TEpic } from "Redux/Config";

export const findSpotListEpic:TEpic = (action$, store$, { SpotListRepository }) => {
    return action$.pipe(
        ofType(FIND_SPOT_LIST_REQUEST),
        mergeMap( action =>{
            const { id } = action.payload;

            if(!id.trim()) {
                return EMPTY;
            }

            return from(
                SpotListRepository.findById( id )
                    .then(spotList => findSpotListSuccess(spotList))
                    .catch(error => findSpotListFailure(error)),
            );
        }),
    );
}
